var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.76314L0.63655 6.10651C0.454484 5.9138 0.454484 5.61248 0.63655 5.41977L1 5.76314ZM5.86345 10.1829C6.05309 10.3836 6.0441 10.7001 5.84337 10.8897C5.64264 11.0794 5.32619 11.0704 5.13655 10.8697L5.86345 10.1829ZM5.13655 0.656628C5.32619 0.4559 5.64264 0.44691 5.84337 0.636549C6.0441 0.826188 6.05309 1.14264 5.86345 1.34337L5.13655 0.656628ZM1.36345 5.41977L5.86345 10.1829L5.13655 10.8697L0.63655 6.10651L1.36345 5.41977ZM5.86345 1.34337L1.36345 6.10651L0.63655 5.41977L5.13655 0.656628L5.86345 1.34337Z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLight);
export default __webpack_public_path__ + "static/media/arrow-light.c57dd9933cb490dfbbc71abc16b155d2.svg";
export { ForwardRef as ReactComponent };